import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 10h-14l4 -4","key":"svg-0"}],["path",{"d":"M7 14h14l-4 4","key":"svg-1"}]]

const IconArrowsExchange2 = createReactComponent('outline', 'arrows-exchange-2', 'ArrowsExchange2', __iconNode);

export default IconArrowsExchange2;